import React from "react";
import InquiryForm from "../components/InquiryForm";
import { ORGANIZATION_INQUIRY } from "../data/inquiryForms";
import "./Offerings.css";

/** Organizational facilitation + Organization Inquiry Form. */
export default function Organizations() {
  return (
    <section className="section white offerings-page">
      <div className="container">
        <h1>Organizational Facilitation</h1>
        <div className="offering-intro">
          <p>
            Looking for a one-time or short-term art therapy experience for your group? I work with nonprofits, galleries, community programs, corporate teams, and organizations across The Bahamas to deliver facilitated art therapy and wellness sessions for groups of all sizes and ages.
          </p>
          <p>
            Whether it’s a staff wellness day, a community workshop, a team bonding session, or a special event, I’ll work with you to create something meaningful and tailored to your group. Pricing varies based on group size, format, and scope.
          </p>
          <p>Fill out the form below and I’ll be in touch.</p>
        </div>
        <div className="inquiry-wrap">
          <InquiryForm form={ORGANIZATION_INQUIRY} />
        </div>
      </div>
    </section>
  );
}
